export default [
  {
    title: 'Home',
    route: 'home',
    icon: 'HomeIcon',
  },
  {
    title: 'Cadastros',
    icon: 'PlusSquareIcon',

    children: [
      {
        title: 'Usuários',
        route: 'list-users',

      },
      {
        title: 'Empresas',
        route: 'list-empresas',

      },

      {
        title: 'Tipos de Unidade',
        route: 'list-tipo_unidades',

      },
      {
        title: 'Unidades',
        route: 'list-unidades',

      },
      {
        title: 'Unidade Config',
        route: 'list-unidade-configs',

      },
    ]
  },
  {
    title: 'Modelo de Pesquisa',
    icon: 'MonitorIcon',

    children: [

      {
        title: 'Modelos',
        route: 'list-modelos',

      },
      {
        title: 'Modelos de Pergunta',
        route: 'list-modelo_perguntas',

      },
      {
        title: 'Modelos de Resposta',
        route: 'list-modelo_respostas',

      },

    ]
  },

  {
    title: 'Pesquisa',
    icon: 'SearchIcon',

    children: [

      {
        title: 'Pesquisa',
        route: 'list-perguntas',

      },
      // {
      //   title: 'Respostas',
      //   route: 'list-respostas',

      // },

    ]
  },
]
